export default "__VITE_ASSET__CDpiCKsY__"